const duracionConAjuste = (seccion, idx, ajustes) => {
  const ajuste = parseInt(ajustes?.[String(idx)], 10) || 0
  return (seccion.duracion_seg || 0) + ajuste
}

export const calculaTiempoEnVivo = ({ estado, secciones = [], ahora = Date.now() }) => {
  const totalPlaneadoSeg = secciones.reduce((s, x) => s + (x.duracion_seg || 0), 0)

  if (!estado || !estado.iniciado_en) {
    return {
      iniciado: false,
      pausado: false,
      seccionIdx: 0,
      tiempoRestanteSeg: secciones[0]?.duracion_seg || 0,
      duracionSeccionActualSeg: secciones[0]?.duracion_seg || 0,
      transcurridoTotalSeg: 0,
      totalPlaneadoSeg,
      porcentajeTotal: 0,
      terminado: false
    }
  }

  if (estado.terminado_en) {
    return {
      iniciado: true,
      pausado: false,
      terminado: true,
      seccionIdx: estado.seccion_idx || 0,
      tiempoRestanteSeg: 0,
      duracionSeccionActualSeg: 0,
      transcurridoTotalSeg: totalPlaneadoSeg,
      totalPlaneadoSeg,
      porcentajeTotal: 100
    }
  }

  const iniciadoEnMs = new Date(estado.iniciado_en).getTime()
  const pausadoAcumuladoSeg = estado.tiempo_pausado_acumulado_seg || 0
  const pausadoEnMs = estado.pausado_en ? new Date(estado.pausado_en).getTime() : null

  const efectivoAhora = pausadoEnMs || ahora
  const totalElapsedSeg = Math.floor((efectivoAhora - iniciadoEnMs) / 1000) - pausadoAcumuladoSeg

  const seccionIdx = estado.seccion_idx || 0
  const ajustes = estado.ajustes_seccion || {}

  const duracionSeccionesAnterioresSeg = secciones
    .slice(0, seccionIdx)
    .reduce((sum, sec, idx) => sum + duracionConAjuste(sec, idx, ajustes), 0)

  const transcurridoEnSeccionActualSeg = Math.max(0, totalElapsedSeg - duracionSeccionesAnterioresSeg)

  const seccionActual = secciones[seccionIdx] || { duracion_seg: 0 }
  const duracionSeccionActualSeg = duracionConAjuste(seccionActual, seccionIdx, ajustes)
  const tiempoRestanteSeg = Math.max(0, duracionSeccionActualSeg - transcurridoEnSeccionActualSeg)

  const totalAjustadoSeg = secciones.reduce(
    (sum, sec, idx) => sum + duracionConAjuste(sec, idx, ajustes),
    0
  )
  const porcentajeTotal = totalAjustadoSeg > 0
    ? Math.min(100, Math.round((totalElapsedSeg / totalAjustadoSeg) * 100))
    : 0

  return {
    iniciado: true,
    pausado: Boolean(pausadoEnMs),
    seccionIdx,
    tiempoRestanteSeg,
    duracionSeccionActualSeg,
    transcurridoTotalSeg: totalElapsedSeg,
    totalPlaneadoSeg,
    porcentajeTotal,
    terminado: false
  }
}

export const formatMmSs = (totalSeg) => {
  const sign = totalSeg < 0 ? '-' : ''
  const abs = Math.abs(totalSeg)
  const mm = Math.floor(abs / 60)
  const ss = abs % 60
  return `${sign}${mm}:${ss.toString().padStart(2, '0')}`
}
